module.exports = __webpack_public_path__ + "media/img/payment-methods/verve-55668e8c3a5193b952526204a03424e1.svg";